// NOTE: No translate at this moment
export default {
    contracts: 'កិច្ចសន្យា',
    service_provision_contracts: 'កិច្ចសន្យានៃការផ្តល់សេវាកម្ម',
    service_contract: 'Service Contract',
    contract_id: 'កិច្ចសន្យាសេវាកម្ម',
    effective_date: 'កាលបរិច្ឆេទមានប្រសិទ្ធភាព',
    service_provision_contract: 'Service provision contract',
    service_subscriber_with_party: 'Service Subscriber ({party})',
    service_provider_with_party: 'Service Provider ({party})',
    party_a: 'Party A',
    party_b: 'Party B',
    download_template: {
        after_due_consideration:
            'After due consideration, the Parties agree to enter into this Service Provision Contract (hereinafter referred to as the “Contract”) under the following terms and conditions:',
        representative_of_with_party: 'Representative of {party}',
        aws_service_description: {
            title: 'AWS Consultancy and Support Services provided on an hourly basis.',
            content_1:
                'Support will be charged on an hourly basis at the rate of {amountPerHour} per hour.',
            content_2:
                'Billing will be done monthly, based on the actual number of support hours utilized.',
            content_3:
                'This support applies to all AWS users under Party A’s account (AWS Account ID: {awsAccountId}).',
        },
        signed_info_with_date:
            'Confirmed via system{lineBreak}Signed on {signDate}',
        seller_signed_info_with_date:
            'Electronically approved{lineBreak}Date {signDate}',
    },
    unconfirmed: 'មិនបានបញ្ជាក់',
    confirmed: 'បានបញ្ជាក់',
};
